import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  SetupCampaignFormContext,
  SetupCampaignFormState,
  setupCampaignFormStateDefault,
  setupCampaignSchemaDefault,
} from '@Forms/campaign/SetupCampaignFormContext';

export const SetupCampaignFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<SetupCampaignFormState>>>(
    setupCampaignSchemaDefault
  );
  const methods = useForm({
    defaultValues: setupCampaignFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <SetupCampaignFormContext.Provider value={value}>{children}</SetupCampaignFormContext.Provider>
  );
};
